import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_5821f5be from 'nuxt_plugin_plugin_5821f5be' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_be0b5e34 from 'nuxt_plugin_bootstrapvue_be0b5e34' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_plugin_6de1961e from 'nuxt_plugin_plugin_6de1961e' // Source: ./nuxt-seo-meta/plugin.js (mode: 'all')
import nuxt_plugin_amp_1b9a8729 from 'nuxt_plugin_amp_1b9a8729' // Source: ./amp.js (mode: 'all')
import nuxt_plugin_gtm_2638e24d from 'nuxt_plugin_gtm_2638e24d' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_0c651964 from 'nuxt_plugin_pluginutils_0c651964' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3d84ddaf from 'nuxt_plugin_pluginrouting_3d84ddaf' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6524f7c0 from 'nuxt_plugin_pluginmain_6524f7c0' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_46c1cc92 from 'nuxt_plugin_axios_46c1cc92' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_99e005da from 'nuxt_plugin_workbox_99e005da' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_cf9efdb4 from 'nuxt_plugin_metaplugin_cf9efdb4' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_c64fb2cc from 'nuxt_plugin_iconplugin_c64fb2cc' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'all')
import nuxt_plugin_localStorage_830ec59e from 'nuxt_plugin_localStorage_830ec59e' // Source: ../plugins/localStorage.js (mode: 'client')
import nuxt_plugin_modal_640f2cc0 from 'nuxt_plugin_modal_640f2cc0' // Source: ../plugins/modal.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_lazyLoad_5abf3c07 from 'nuxt_plugin_lazyLoad_5abf3c07' // Source: ../plugins/lazyLoad.js (mode: 'all')
import nuxt_plugin_toastify_a40165a8 from 'nuxt_plugin_toastify_a40165a8' // Source: ../plugins/toastify.js (mode: 'all')
import nuxt_plugin_nouislider_66d8556a from 'nuxt_plugin_nouislider_66d8556a' // Source: ../plugins/nouislider.js (mode: 'all')
import nuxt_plugin_aos_3e747fca from 'nuxt_plugin_aos_3e747fca' // Source: ../plugins/aos.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ar"},"title":"شركة مملكة النحل","titleTemplate":"شركة مملكة النحل","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"شركة مملكة النحل"},{"hid":"keywords","name":"keywords","content":"شركة مملكة النحل"},{"name":"author","content":"ATW Ltd"},{"name":"keywords","content":"شركة مملكة النحل"},{"name":"app-mobile-web-app-title","content":"شركة مملكة النحل"},{"name":"application-name","content":"شركة مملكة النحل"},{"name":"msapplication-TileColor","content":"#cc9966"},{"name":"msapplication-config","content":"\u002Fimages\u002Ficons\u002Fbrowserconfig.xml"},{"property":"og:site_name","content":"شركة مملكة النحل"},{"hid":"og:type","property":"og:type","content":"شركة مملكة النحل"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fweb.royalbeeseg.com\u002F"},{"hid":"og:title","property":"og:title","content":"شركة مملكة النحل"},{"hid":"og:description","property":"og:description","content":"شركة مملكة النحل"},{"hid":"og:image","property":"og:image","content":"@\u002Fimages\u002FAlf\u002Funnamed.png"},{"property":"og:image:width","content":"740"},{"property":"og:image:height","content":"300"},{"name":"twitter:site","content":"@bobross"},{"name":"twitter:card","content":"شركة مملكة النحل"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fweb.royalbeeseg.com\u002F"},{"hid":"twitter:title","name":"twitter:title","content":"شركة مملكة النحل"},{"hid":"twitter:description","name":"twitter:description","content":"شركة مملكة النحل"},{"hid":"author","name":"author","content":"https:\u002F\u002Fweb.royalbeeseg.com\u002F"},{"hid":"publisher","name":"publisher","content":"https:\u002F\u002Fweb.royalbeeseg.com\u002F"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"شركة مملكة النحل"},{"hid":"theme-color","name":"theme-color","content":"#fcb932"},{"hid":"og:title","property":"og:title","content":"شركة مملكة النحل"},{"hid":"og:description","property":"og:description","content":"شركة مملكة النحل"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fweb.royalbeeseg.com\u002F"},{"hid":"og:image","property":"og:image","content":"@\u002Fimages\u002FAlf\u002Funnamed.png"},{"hid":"og:image:width","property":"og:image:width","content":"30"},{"hid":"og:image:height","property":"og:image:height","content":"30"},{"hid":"og:locale","property":"og:locale","content":"en_US"},{"hid":"og:site_name","property":"og:site_name","content":"شركة مملكة النحل"},{"hid":"twitter:card","name":"twitter:card","content":"ATW"},{"hid":"twitter:site","name":"twitter:site","content":"ATW"},{"hid":"twitter:creator","name":"twitter:creator","content":"ATW"},{"hid":"twitter:title","name":"twitter:title","content":"شركة مملكة النحل"},{"hid":"twitter:description","name":"twitter:description","content":"شركة مملكة النحل"},{"hid":"twitter:image","name":"twitter:image","content":"@\u002Fimages\u002FAlf\u002Funnamed.png"},{"hid":"twitter:image:width","name":"twitter:image:width","content":"30"},{"hid":"twitter:image:height","name":"twitter:image:height","content":"30"}],"link":[{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":".\u002Fimages\u002Ficons\u002Falf32-32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":".\u002Fimages\u002Ficons\u002Falf16-16.png"},{"rel":"shortcut icon","href":".\u002Fimages\u002Ficons\u002Ffav32-32.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":".\u002Fimages\u002Ficons\u002Fapple-touch-icon.png"},{"rel":"manifest","href":".\u002Fimages\u002Ficons\u002Fsite.webmanifest"},{"rel":"mask-icon","color":"#666666","href":".\u002Fimages\u002Ficons\u002Fsafari-pinned-tab.svg"},{"rel":"apple-touch-startup-image","media":"screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","href":"@\u002Fimages\u002FAlf\u002Falf-logo.png"}],"script":[],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_5821f5be === 'function') {
    await nuxt_plugin_plugin_5821f5be(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_be0b5e34 === 'function') {
    await nuxt_plugin_bootstrapvue_be0b5e34(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_6de1961e === 'function') {
    await nuxt_plugin_plugin_6de1961e(app.context, inject)
  }

  if (typeof nuxt_plugin_amp_1b9a8729 === 'function') {
    await nuxt_plugin_amp_1b9a8729(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2638e24d === 'function') {
    await nuxt_plugin_gtm_2638e24d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_0c651964 === 'function') {
    await nuxt_plugin_pluginutils_0c651964(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3d84ddaf === 'function') {
    await nuxt_plugin_pluginrouting_3d84ddaf(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6524f7c0 === 'function') {
    await nuxt_plugin_pluginmain_6524f7c0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_46c1cc92 === 'function') {
    await nuxt_plugin_axios_46c1cc92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_99e005da === 'function') {
    await nuxt_plugin_workbox_99e005da(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_cf9efdb4 === 'function') {
    await nuxt_plugin_metaplugin_cf9efdb4(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_c64fb2cc === 'function') {
    await nuxt_plugin_iconplugin_c64fb2cc(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localStorage_830ec59e === 'function') {
    await nuxt_plugin_localStorage_830ec59e(app.context, inject)
  }

  if (typeof nuxt_plugin_modal_640f2cc0 === 'function') {
    await nuxt_plugin_modal_640f2cc0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyLoad_5abf3c07 === 'function') {
    await nuxt_plugin_lazyLoad_5abf3c07(app.context, inject)
  }

  if (typeof nuxt_plugin_toastify_a40165a8 === 'function') {
    await nuxt_plugin_toastify_a40165a8(app.context, inject)
  }

  if (typeof nuxt_plugin_nouislider_66d8556a === 'function') {
    await nuxt_plugin_nouislider_66d8556a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_3e747fca === 'function') {
    await nuxt_plugin_aos_3e747fca(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
